import { SmlJsonQueryFilter, SmlJsonQueryOrder } from "@src/types/intelligence-search";
import { Form, Input } from "antd";
import { FormInstance } from "antd/lib";
import React, { useLayoutEffect } from "react";
import { IntelligenceFormFieldsEnum } from "@src/pages/intelligence-search/enum";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import {
    TemplateSearchOrderLimit,
    TemplateSearchOrderLimitValue,
} from "@src/components/intelligence-search/template-search";

export const DEFAULT_LIMIT = 1000;
export const OrderAndLimitConfig: React.FC<{ filters: SmlJsonQueryFilter[]; form: FormInstance<any> }> = ({
    filters,
    form,
}) => {
    const options = filters
        .filter((f) => !f.operator)
        .map((f) => ({
            label: f.meta?.title ?? f.meta?.name ?? "",
            value: f.meta?.name ?? "",
            meta: f.meta,
        }));
    const queryOrderWatch = Form.useWatch(IntelligenceFormFieldsEnum.QUERY_ORDER, form);
    const queryLimitWatch = Form.useWatch(IntelligenceFormFieldsEnum.QUERY_LIMIT, form);

    const handleOk = (value: TemplateSearchOrderLimitValue) => {
        form.setFieldsValue({
            [IntelligenceFormFieldsEnum.QUERY_ORDER]: value.orders,
            [IntelligenceFormFieldsEnum.QUERY_LIMIT]: value.limit,
        });
    };

    //sync filter selected with query order
    useLayoutEffect(() => {
        const currentQueryOrder: SmlJsonQueryOrder[] = form.getFieldValue(IntelligenceFormFieldsEnum.QUERY_ORDER) ?? [];

        const newQueryOrder = currentQueryOrder.reduce((acc, currItem) => {
            if (filters.some((f) => !f.operator && f.meta?.name === currItem.name)) {
                acc.push(currItem);
            }
            return acc;
        }, [] as SmlJsonQueryOrder[]);
        form.setFieldValue(IntelligenceFormFieldsEnum.QUERY_ORDER, newQueryOrder);
    }, [filters, form]);

    return (
        <>
            <TemplateSearchOrderLimit
                initValue={{
                    orders: queryOrderWatch,
                    limit: queryLimitWatch,
                }}
                options={options}
                renderLabelOption={(option) => (
                    <div
                        style={{
                            color: getMemberColor(option?.meta?.asset_type).textColor,
                        }}
                    >
                        {option.meta?.title ?? option.meta?.name ?? ""}
                    </div>
                )}
                handleOk={handleOk}
            />
            <Form.Item name={IntelligenceFormFieldsEnum.QUERY_ORDER} hidden>
                <Input />
            </Form.Item>
            <Form.Item name={IntelligenceFormFieldsEnum.QUERY_LIMIT} hidden>
                <Input />
            </Form.Item>
        </>
    );
};
